<ng-template #footerTmpl>
  @if (active) {
    <div class="footer" [class.no-padding-bottom]="withNewStyling && replyToId" padding-top-small>
      @if (attachmentsTemp?.length || note?.attachments?.length || attachmentLoading) {
        <rt-divider variant="line dark"></rt-divider>
      }
      @if (attachmentLoading) {
        <rt-spinner variant="small"> </rt-spinner>
      }
      @for (tempUpload of attachmentsTemp; track trackByTempUpload($index, tempUpload)) {
        <rt-attachment-item
          [attachment]="tempUpload.attachment"
          [hasDeleteAction]="canDeleteAttachments"
          (deleteClick)="deleteAttachment($event)"
          type="list-item"
          margin-bottom-small
        >
        </rt-attachment-item>
      }
      @if (note) {
        @for (attachment of note.attachments; track trackById($index, attachment)) {
          <rt-attachment-item
            [attachment]="attachment"
            [hasDeleteAction]="canDeleteAttachments"
            (deleteClick)="deleteAttachment($event)"
            type="list-item"
            margin-bottom-small
          >
          </rt-attachment-item>
        }
      }
      @if (
        !attachmentsTemp?.length &&
        !note?.attachments?.length &&
        (hasVisibilityOptions() || !withNewStyling)
      ) {
        <rt-divider variant="line dark" margin-bottom-small></rt-divider>
      }
      <div class="footer-actions">
        @if (hasVisibilityOptions()) {
          <rt-visibility-selector-container
            [visibility]="state.visibility"
            [avatarMaxLength]="1"
            [wrapOnSmallerResolutions]="isSmallResolution"
            [candidateId]="candidateId"
            [groupUsersByAccess]="!!candidateId"
            (mousedown)="setKeepFocus()"
            (visibilityChanges)="onVisibilityChanges($event)"
          ></rt-visibility-selector-container>
        }
        @if (!withNewStyling) {
          <ng-container *ngTemplateOutlet="actionsTpl"></ng-container>
        }
      </div>
    </div>
  }
</ng-template>

<input #fileInput type="file" hidden (change)="uploadAttachment(fileInput.files, fileInput)" />

<div class="form" [class.active]="active" [class.new]="withNewStyling">
  <div class="mentions-input" [class.mentions-input--active]="active">
    <rt-wysiwyg
      prosemirrorGroupedConfig
      [formControl]="wysiwygControl"
      [placeholder]="placeholder"
      [actionButtons]="actionButtons"
      [withBorder]="false"
      [toolbarVisible]="active"
      [footerTmpl]="footerTmpl"
      [autofocus]="autofocus"
      [config]="ProsemirrorGroupedConfig"
      (focusChange)="onFocusChange($event)"
      (editorEvents)="onEditorEvents($event)"
    >
    </rt-wysiwyg>
  </div>
</div>

@if (active && withNewStyling) {
  <ng-container *ngTemplateOutlet="actionsTpl"></ng-container>
}
<ng-template #actionsTpl>
  <div [attr.margin-tb-small]="withNewStyling || null" [class.actions-right]="!withNewStyling">
    <rt-group variant="horizontal" [attr.layout-justify-flex-end]="withNewStyling || null">
      <rt-button variant="plain" (click)="cancel()" margin-right-small>
        {{ 'app.common.cancel' | translate }}
      </rt-button>
      <rt-button
        class="action"
        variant="primary"
        [loading]="noteSaveLoading"
        [disabled]="!isValid()"
        (mousedown)="setKeepFocus()"
        (click)="save()"
      >
        {{ 'app.common.save' | translate }}
      </rt-button>
    </rt-group>
  </div>
</ng-template>
